import clsx from 'clsx';
import { isOnPremises } from 'libs/env';
import Image from 'next/image';
import Link from 'next/link';
import { copyright } from 'pages/pages';
import layoutFooter from './_styles/layout/footer.module.scss';
import layoutMain from './_styles/layout/main.module.scss';
import objectUtilityFlex from './_styles/object/utility/flex.module.scss';
import pageRegistration from './_styles/page/registration.module.scss';

export const SignInFooter = () => {
  return (
    <footer
      className={clsx(layoutFooter['l-footer'], pageRegistration['l-footer'])}
    >
      <div className={clsx(layoutMain['l-main'], pageRegistration['l-main'])}>
        <div
          className={clsx(
            objectUtilityFlex['u-flex'],
            layoutFooter['u-flex'],
            pageRegistration['u-flex']
          )}
        >
          <p className={layoutFooter['l-footer-logo']}>
            <Image
              alt=""
              src="/images/logo-white.png"
              width={130}
              height={31}
            />
          </p>
          {!isOnPremises() && (
            <ul
              className={clsx(layoutFooter['l-footer-list'], 'list-unstyled')}
            >
              <li>
                <dl>
                  <dt>About</dt>
                  <dd>
                    <Link href="https://signate.co.jp">運営会社</Link>
                  </dd>
                  <dd>
                    <Link href="https://signate.co.jp/privacy">
                      プライバシーポリシー
                    </Link>
                  </dd>
                  <dd>
                    <Link
                      href={`${process.env.NEXT_PUBLIC_SIGNATE_CLOUD_SUPPORT_INQUIRIES_URL}`}
                      target="_blank"
                    >
                      お問い合わせ
                    </Link>
                  </dd>
                </dl>
              </li>
            </ul>
          )}
        </div>
        <p className={layoutFooter['l-footer-copy']}>{copyright}</p>
      </div>
    </footer>
  );
};
